import React from 'react';
import { App } from '@mb/App';
import ReactDOM from 'react-dom';

import { ThemeContainer } from 'ui-widgets';

import { AppContainer } from '../../pages/Event/containers/AppContainer/AppContainer';

const EventApp = () => {
  return (
    <App>
      <ThemeContainer>
        <AppContainer />
      </ThemeContainer>
    </App>
  );
};

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(<EventApp />, document.getElementById('eventContent'));
